/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Orchestration_Desc13Inputs */

const en_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple specialized agents that collaborate on complex workflows, planner, executor, reviewer, with hand-offs that don't lose context.`)
};

const ar_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء متخصصون متعددون يتعاونون على سير عمل معقد، مخطط ومنفذ ومراجع، مع انتقال لا يفقد السياق.`)
};

const bn_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জটিল ওয়ার্কফ্লোতে সহযোগিতা করা একাধিক বিশেষায়িত এজেন্ট, প্ল্যানার, এক্সিকিউটর, রিভিউয়ার, কনটেক্সট না হারিয়ে হ্যান্ড-অফসহ।`)
};

const de_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere spezialisierte Agenten, die an komplexen Arbeitsabläufen zusammenarbeiten: Planer, Executor, Reviewer, mit Übergaben, die den Kontext nicht verlieren.`)
};

const es_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Múltiples agentes especializados que colaboran en flujos de trabajo complejos, planificador, ejecutor, revisor, con traspasos que no pierden el contexto.`)
};

const fr_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs agents spécialisés qui collaborent sur des flux de travail complexes, planificateur, exécuteur, reviewer, avec des transferts qui ne perdent pas le contexte.`)
};

const pt_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vários agentes especializados que colaboram em fluxos de trabalho complexos, planejador, executor, revisor, com transferências que não perdem o contexto.`)
};

const zh_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多个专业智能体协作处理复杂工作流，分别负责规划、执行、评审，交接不丢上下文。`)
};

const tr_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlayıcı, yürütücü, reviewer rolleriyle karmaşık akışlarda birlikte çalışan uzman ajanlar, bağlam kaybetmeyen devirlerle.`)
};

const ru_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Несколько спецагентов, вместе ведущих сложные флоу: планировщик, исполнитель, ревьюер, с передачами без потери контекста.`)
};

const pl_svc_ai_agent_development_orchestration_desc13 = /** @type {(inputs: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wielu wyspecjalizowanych agentów współpracujących przy złożonych przepływach pracy: planista, wykonawca, reviewer, z przekazaniami bez utraty kontekstu.`)
};

/**
* | output |
* | --- |
* | "Multiple specialized agents that collaborate on complex workflows, planner, executor, reviewer, with hand-offs that don't lose context." |
*
* @param {Svc_Ai_Agent_Development_Orchestration_Desc13Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_orchestration_desc13 = /** @type {((inputs?: Svc_Ai_Agent_Development_Orchestration_Desc13Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Orchestration_Desc13Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "de") return de_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "es") return es_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_orchestration_desc13(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_orchestration_desc13(inputs)
	return en_svc_ai_agent_development_orchestration_desc13(inputs)
});
export { svc_ai_agent_development_orchestration_desc13 as "svc_ai-agent-development_ORCHESTRATION_desc" }